import { Component, OnInit, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { PaginationInstance } from 'ngx-pagination';
import { DatePipe } from '@angular/common';
import { DestroySubscribers } from 'src/app/theme/utils/util-functions';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
@DestroySubscribers()
export class HomeComponent implements OnInit,OnDestroy {

  public slides = [
    { title: 'The biggest sale', subtitle: 'Special for today', image: 'assets/images/carousel/banner1.jpg' },
    { title: 'Summer collection', subtitle: 'New Arrivals On Sale', image: 'assets/images/carousel/banner2.jpg' },
    { title: 'The biggest sale', subtitle: 'Special for today', image: 'assets/images/carousel/banner3.jpg' },
    { title: 'Summer collection', subtitle: 'New Arrivals On Sale', image: 'assets/images/carousel/banner4.jpg' },
    { title: 'The biggest sale', subtitle: 'Special for today', image: 'assets/images/carousel/banner5.jpg' }
  ];

  public brands: any;
  public banners; any;
  public featuredProducts = [];
  public onSaleProducts: any;
  public topRatedProducts: any;
  public newArrivalsProducts = [];
  public storeDetails = {};
  paginationDetails = {};
  featuredlimit = 9;
  newArrivallimit = 9;
  featuredCount: any;
  newArrivalCount: any;
  storeDetailsJson: any;
  subService;
  orderCutOff;
  cutOffDateTime;
  categories: any;
  array = [1, 2, 3];
  pageLoaded = false;
  isShowCutOffMessage: boolean = false;
  showMessage = false;
  platformServer = false;
  featuredPage = 1;
  newArrivalpage = 1;
  isLoggedIn = false;
  featureTags = {};
  private destroy$ = new Subject<void>();
  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  constructor(public apiService: ApiService, private activatedRoute: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object,
    private subscriptionService: SubscriptionService, public router: Router, private datePipe: DatePipe, public sharedDataService: SharedDataService) { }

  ngOnInit() {
    this.featureTags = JSON.parse(
      sessionStorage.getItem("featureTags")
    );
    if(!!this.featureTags && this.featureTags['sf_show_featured_products_issue']){ 
      this.featuredlimit = 12;
      this.newArrivallimit = 12;   
    }else{
      this.featuredlimit = 9;
      this.newArrivallimit = 9; 
    }
    if (isPlatformBrowser(this.platformId)) {
      this.showMessage = true;
    }
    if (isPlatformServer(this.platformId)) {
      this.platformServer = true;
    }
    this.storeDetails = this.activatedRoute.snapshot.data['store']['response']['data']['store'];
    this.storeDetailsJson = this.activatedRoute['snapshot']['data']['store']['response']['data']['store_json'];
    this.isLoggedIn = this.apiService.loggedIn();
    this.getCategories();
    this.cutOffDateTime = JSON.parse(sessionStorage.getItem('cutoff'));
    this.orderCutOff = this.cutOffDateTime  ? this.datePipe.transform(this.cutOffDateTime[0]["storeCutOffTime"], 'MM/dd/yy h:mm a') : "";
    let cut_off_message = sessionStorage.getItem('cut_off_message');
    this.isShowCutOffMessage = !!cut_off_message && cut_off_message === "hide" ? false : true;
    this.subService = this.subscriptionService.getSubject()
    .pipe(takeUntil(this.destroy$))
    .subscribe(val => {
      if (val['refresh'] === true) {
        this.getNewAndFeatured();
      }
    });
  }

  getCategories() {
    this.apiService.categories()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        this.categories = result['response']['data']['cat_list'];
      }
      this.getNewAndFeatured();
    }, (error) => {
      this.getNewAndFeatured();
      if (error) {
        console.log(error);
      }
    });
  }
  getNewAndFeatured() {
    this.getNewArrivals("new arrivals");
    this.getfeatured("featured");
  }
  getNewArrivals(value) {
    this.apiService.getProductsBasedOnCategory({ page: this.newArrivalpage, limit: this.newArrivallimit, category_url: 'new@1_product' })
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (data['response']['status'] === 1 || data['response']['status'] === 6) {
        this.newArrivalsProducts = data['response']['data']['products']['new_arrival'];
        this.newArrivalsProducts['storeDetailsJson'] = this.storeDetailsJson;
        this.newArrivalsProducts['categories'] = this.categories;
        this.newArrivalsProducts['type'] = 'newArrival';
        // this.newArrivalsProducts['arrivalPage'] = this.newArrivalpage;
        this.newArrivalsProducts['count'] = data['response']['data']['products']['count'];
        this.newArrivalCount = data['response']['data']['products']['count'];
        // this.newArrivallimit = this.newArrivalCount;
      } else {
        this.newArrivalsProducts = [];
      }
      if (isPlatformBrowser(this.platformId)) {
        this.pageLoaded = true;
      }
      this.sharedDataService.cartLoading.next(false);
    }, error => {
      this.newArrivalsProducts = [];
      if (isPlatformBrowser(this.platformId)) {
        this.pageLoaded = true;
      }
      this.sharedDataService.cartLoading.next(false);
      return of(null); // In SSR, Prevent memory leaks by returning a safe value
    })
  }
  getfeatured(value) {

    this.apiService.getProductsBasedOnCategory({ page: this.featuredPage, limit: this.featuredlimit, category_url: 'fe@tured1_product' })
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (data['response']['status'] === 1 || data['response']['status'] === 6) {
        this.featuredProducts = data['response']['data']['products']['featured_product'];
        this.featuredProducts['storeDetailsJson'] = this.storeDetailsJson;
        this.featuredProducts['categories'] = this.categories;
        this.featuredProducts['type'] = 'featured';
        // this.featuredProducts['featuredPage'] = this.featuredPage;
        this.featuredProducts['count'] = data['response']['data']['products']['count']
        this.featuredCount = data['response']['data']['products']['count']
        // this.featuredlimit = this.featuredCount;
      } else {
        this.featuredProducts = [];
      }
      if (isPlatformBrowser(this.platformId)) {
        this.pageLoaded = true;
      }
      this.sharedDataService.cartLoading.next(false);
    }, error => {
      this.featuredProducts = [];
      if (isPlatformBrowser(this.platformId)) {
        this.pageLoaded = true;
      }
      this.sharedDataService.cartLoading.next(false);
      return of(null); // In SSR, Prevent memory leaks by returning a safe value
    })
  }

  closeCutOffMessage() {
    this.isShowCutOffMessage = false;
    sessionStorage.setItem('cut_off_message', 'hide');
  }

  goTofeatured() {
    this.router.navigate(['/categories', 'new@1_product']);
  }
  getFeaturedData(event) {
    this.featuredPage = event.pageIndex + 1;
    this.getfeatured("featured");
  }
  getNewArrivalData(event) {
    this.newArrivalpage = event.pageIndex + 1;
    this.getNewArrivals("new arrivals");
  }

  ngOnDestroy() {
    !!this.subService && this.subService.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
